(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function guard(form) {
      var hp = form.querySelector('.contact-form__hp input');
      if (!hp) return;
      form.addEventListener('submit', function (event) {
        if (hp.value.trim() !== '') {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }

    function init() {
      document.querySelectorAll('.contact-form__form').forEach(guard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eratec-frequently-bought"] && !Shopify.designMode) return;
  try {
    class EratecFrequentlyBought extends HTMLElement {
    connectedCallback() {
      this.cartAddUrl = this.dataset.cartAddUrl || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js');
      this.status = this.querySelector('[data-fbt-status]');
      this.busy = false;

      // Auf das native Add-to-Cart der Produktseite hoeren. CartAddEvent nutzt denselben
      // Event-Namen wie cartUpdate ('cart:update'); wir filtern auf die Quelle 'product-form-component'.
      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.scope = this.closest('.shopify-section, dialog') || document;
      this.scope.addEventListener('cart:update', this.onCartUpdate);
    }

    disconnectedCallback() {
      if (this.scope) this.scope.removeEventListener('cart:update', this.onCartUpdate);
    }

    get selectedVariantIds() {
      return Array.from(this.querySelectorAll('.eratec-fbt__checkbox:checked'))
        .map((input) => Number(input.value))
        .filter((id) => Number.isFinite(id) && id > 0);
    }

    async onCartUpdate(event) {
      const data = event && event.detail ? event.detail.data : null;

      // Nur reagieren, wenn der HAUPT-"In den Warenkorb"-Button erfolgreich ausgeloest hat —
      // nicht bei Fehlern und nicht beim eigenen Nachladen (Schutz vor Endlosschleife).
      if (!data) return;
      if (data.source !== 'product-form-component') return;
      if (data.didError) return;
      if (this.busy) return;

      const variantIds = this.selectedVariantIds;
      if (variantIds.length === 0) return;

      this.busy = true;

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      const payload = {
        items: variantIds.map((id) => ({ id, quantity: 1 })),
      };
      if (sectionIds.length > 0) payload.sections = sectionIds.join(',');

      try {
        const response = await fetch(this.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error('cart_add_failed');
        const result = await response.json();

        // Angehakte Add-ons wieder zuruecksetzen (sie sind nun im Warenkorb).
        this.querySelectorAll('.eratec-fbt__checkbox:checked').forEach((input) => {
          input.checked = false;
        });

        if (this.status) {
          this.status.textContent = this.status.getAttribute('data-added-text') || '';
        }

        // Native Cart-Drawer/Counter ueber das offizielle cart:update-Event aktualisieren.
        // Eigene Quelle setzen, damit dieser Block nicht erneut auf sich selbst reagiert.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: null,
              sourceId: this.dataset.testid || 'eratec-frequently-bought',
              data: {
                source: 'eratec-frequently-bought',
                sections: result && result.sections ? result.sections : undefined,
              },
            },
          })
        );
      } catch (error) {
        // Stiller Fehlerfall: der Hauptartikel ist bereits im Warenkorb, der Nutzer
        // kann die Add-ons erneut waehlen. Keine Blockade der Produktseite.
      } finally {
        this.busy = false;
      }
    }
  }

  if (!customElements.get('eratec-frequently-bought')) {
    customElements.define('eratec-frequently-bought', EratecFrequentlyBought);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eratec-nav-mega"] && !Shopify.designMode) return;
  try {
    /*
    Die Versandleiste im Menue stammt vom Seitenaufbau. Bei Warenkorb-Aenderungen
    rendert Horizon nur die cart-items-Sektionen neu (assets/component-cart-items.js),
    der Kopf bleibt stehen — der Restbetrag im Menue waere danach veraltet. Eine falsche
    Zahl zum Versand ist schlimmer als keine: die Leiste verschwindet, der naechste
    Seitenaufruf bringt sie mit dem richtigen Betrag zurueck. Im Warenkorb selbst liegt
    die Leiste in der Morph-Grenze und bleibt aktuell.
  */
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, () => {
      const leisten = document.querySelectorAll(
        '.er-mega__schiene > .eratec-fsb, .er-schublade__rumpf > .eratec-fsb'
      );
      for (const leiste of leisten) leiste.remove();
    });
  }).catch(() => {
    /* Ohne das Ereignis-Modul bleibt alles wie vorher: die Leiste steht bis zum Neuladen. */
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eratec-rechtszeile"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-eratec-cookie]');
    const app = [window.Consentmo, window.Pandectes].find((a) => a && typeof a.openDialog === 'function');
    if (!link) return;
    // Pandectes ohne API (Plan unter Enterprise): dessen eigenen Widget-Knopf ausloesen.
    const widget = document.querySelector('pandectes-cmp')?.shadowRoot?.querySelector('button.widget');
    // Shopifys eigenes Cookie-Banner (Kundendatenschutz), falls keine App aktiv ist.
    const shopifyBanner = window.privacyBanner;
    if (!app && !widget && !shopifyBanner) return;
    event.preventDefault();
    if (app) app.openDialog('preferences');
    else if (widget) widget.click();
    else shopifyBanner.showPreferences();
  });

  /*
    Der freischwebende Pandectes-Knopf unten links soll nicht im Bild stehen (Atakan,
    Rueckmeldung 8; auf dem Live-Theme war er per CSS weg). Er liegt im Shadow DOM, das
    Theme-CSS nicht erreicht, deshalb wird dort ein eigenes Stylesheet eingehaengt.
    Die Einstellungen bleiben erreichbar: Pandectes tauscht den Knopf beim Klick gegen
    seinen dialog.preferences, und ein Klick auf einen display:none-Knopf loest ihn
    trotzdem aus – genau den Weg nimmt der Cookie-Link darueber.
  */
  const erWidgetVerbergen = () => {
    const host = document.querySelector('pandectes-cmp');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.querySelector('#er-cmp-widget-aus')) return true;
    const stil = document.createElement('style');
    stil.id = 'er-cmp-widget-aus';
    /*
      Dazu die Trefferflaechen im Banner selbst: die drei Links in seinem Einleitungstext
      ("Cookie-Richtlinie", "Impressum", Google) messen unter 24 px und waren der einzige
      Fehlschlag von Lighthouse a11y auf dem gehosteten Shop (97 statt 100, Phase 8).
      Nur Abstand, keine Farbe, keine Groesse - das Banner bleibt das der App.
    */
    stil.textContent =
      'button.widget{display:none !important}' +
      '.intro .links a,.links a{display:inline-block;min-height:24px;padding-block:4px}';
    host.shadowRoot.append(stil);
    return true;
  };

  if (!erWidgetVerbergen()) {
    const beobachter = new MutationObserver(() => {
      if (erWidgetVerbergen()) beobachter.disconnect();
    });
    beobachter.observe(document.documentElement, { childList: true, subtree: true });
    // Laedt die App gar nicht, wird nicht endlos beobachtet.
    setTimeout(() => beobachter.disconnect(), 15000);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eratec-savings"] && !Shopify.designMode) return;
  try {
    // Companion for <eratec-savings>. Mirrors the native product-price.js update flow,
  // but as a plain custom element (block-level JS runs outside module scope, so
  // it cannot import @theme/events — it listens for the stable 'variant:update' string).
  // On variant change the variant picker dispatches the event on the section with the
  // freshly server-rendered HTML; we swap our own inner content (found by data-block-id)
  // so the savings update in BOTH directions, including sale -> no-sale (empty) and back.
  if (!customElements.get('eratec-savings')) {
    class EratecSavings extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section, dialog');
        if (!this.section) return;
        this.section.addEventListener('variant:update', this.updateSavings);
      }

      disconnectedCallback() {
        if (!this.section) return;
        this.section.removeEventListener('variant:update', this.updateSavings);
      }

      updateSavings = (event) => {
        const data = event.detail && event.detail.data;
        if (!data || !data.html) return;

        // Combined listing: adopt the new product id. Otherwise ignore updates that
        // belong to a different product form on the page.
        if (data.newProduct) {
          this.dataset.productId = data.newProduct.id;
        } else if (
          event.target instanceof HTMLElement &&
          event.target.dataset.productId &&
          event.target.dataset.productId !== this.dataset.productId
        ) {
          return;
        }

        const fresh = data.html.querySelector(
          'eratec-savings[data-block-id="' + this.dataset.blockId + '"]'
        );
        if (!fresh) return;

        const currentContainer = this.querySelector('[ref="container"]');
        const freshContainer = fresh.querySelector('[ref="container"]');
        if (!currentContainer || !freshContainer) return;

        // Replace via cloned DOM nodes (no HTML-string parsing) to mirror the native
        // product-price.js node-replacement approach and avoid innerHTML assignment.
        const clones = Array.from(freshContainer.childNodes).map((node) => node.cloneNode(true));
        currentContainer.replaceChildren(...clones);
        this.classList.toggle('eratec-savings--empty', fresh.classList.contains('eratec-savings--empty'));
      };
    }

    customElements.define('eratec-savings', EratecSavings);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["eratec-widerrufsformular"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eratec-widerruf')) {
    const SCHLUESSEL = 'eratec-widerruf';

    class EratecWiderruf extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        const liste = this.querySelector('[data-er-liste]');

        // Vor dem Absenden: sichtbare Beschriftung + Wert jedes Feldes merken.
        if (form && !liste) {
          form.addEventListener('submit', (event) => {
            const falle = form.querySelector('.eratec-widerruf__hp input');
            if (falle && falle.value.trim() !== '') {
              event.preventDefault();
              return;
            }
            const daten = [];
            form.querySelectorAll('input[name^="contact["]:not([data-er-intern]), textarea[name^="contact["]').forEach((feld) => {
              if (!feld.value.trim()) return;
              const label = form.querySelector(`label[for="${feld.id}"]`);
              const titel = label ? label.firstChild.textContent.trim() : feld.name.slice(8, -1);
              daten.push([titel, feld.value.trim()]);
            });
            try {
              sessionStorage.setItem(SCHLUESSEL, JSON.stringify(daten));
            } catch (e) {}
          });
        }

        // Nach dem Absenden: Angaben in die Bestaetigung schreiben.
        if (liste) {
          let daten = [];
          try {
            daten = JSON.parse(sessionStorage.getItem(SCHLUESSEL) || '[]');
          } catch (e) {}
          daten.forEach(([titel, wert]) => {
            const dt = document.createElement('dt');
            const dd = document.createElement('dd');
            dt.textContent = titel;
            dd.textContent = wert;
            liste.append(dt, dd);
          });
          if (daten.length) this.querySelector('[data-er-daten]').hidden = false;
          this.querySelector('[data-er-drucken]')?.addEventListener('click', () => window.print());
        }
      }
    }

    customElements.define('eratec-widerruf', EratecWiderruf);
  }
  } catch(e) { console.error(e); }
})();

})();
